import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'lds-energy-main',
    templateUrl: './energy-main.component.html',
    styleUrls: ['./energy-main.component.css'],
    standalone: false
})
export class EnergyMainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
